import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import LegalPageRoute from './LegalPageRoute'
import { LEGAL_DOCS, type LegalDocKey } from '@gamecodex/portal-ui'
import './index.css'

/**
 * The whole app is one Vite entry — Netlify's catch-all redirect (see
 * netlify.toml) sends every path here, so `/legal/:doc` is resolved by
 * reading the URL once at boot rather than pulling in a router for three
 * static pages.
 */
function isLegalDocKey(v: string): v is LegalDocKey {
  return Object.prototype.hasOwnProperty.call(LEGAL_DOCS, v)
}

const legalMatch = window.location.pathname.match(/^\/legal\/([a-z-]+)\/?$/)
const legalDoc = legalMatch && isLegalDocKey(legalMatch[1]) ? legalMatch[1] : null

createRoot(document.getElementById('root')!).render(
  <StrictMode>{legalDoc ? <LegalPageRoute doc={legalDoc} /> : <App />}</StrictMode>,
)
